module.exports = __webpack_public_path__ + "img/cat.e401ef5a.jpg";